
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type fitmentTableTabDesktopRTRootProps = TemplateRootPropsForTag<'a'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableTabDesktopRT(): TemplateResult<fitmentTableTabDesktopRTRootProps> {
    return this.vehicleSpecific || this.manyFitments ? _createElement('a', {
        'href': '#tab_fitmenttab',
        'className': 'tab-title',
        'role': 'tab',
        'data-toggle': 'tab',
        'aria-controls': 'tab_fitmenttab',
        'key': '0'
    }, '\n  Fitment\n') : null;
}
        export const componentNames = []